module.exports = __webpack_public_path__ + "img/icon.99f90b62.svg";